export default "__VITE_ASSET__3bf55202__"